<template>
  <div class="the-navbar__user-meta items-center custom-nav">
    <ul v-if="servicesWithPermission.length > 1">
      <li :key="idx" v-for="(item, idx) in servicesWithPermission">
        <a
          style="cursor: pointer"
          @click.stop="changeService(item, item.idx)"
          :class="{ active: item.name === currentService.name }"
        >
          {{ item.name }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      servicesWithPermission: "services/servicesWithPermission",
      currentService: "services/currentService",
    }),
  },
  methods: {
    changeService(service, idx) {
      this.switchService(service, idx);
    },
  },

  data() {
    return {};
  },
};
</script>
<style scoped>
@font-face {
  font-family: "HelNeue";
  src: url("./fonts/Helvetica-Neue-Condensed-Bold.woff") format("woff"),
    /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
      url("./fonts/Helvetica-Neue-Condensed-Bold.ttf") format("truetype"); /* Chrome 4+, Firefox 3.5, Opera 10+, Safari 3—5 */
}

ul {
  margin-left: 0.8rem;
  height: 100%;
  display: flex;
  align-items: center;
}

li {
  /* flex: 1; */

  display: inline-block;
  text-align: center;
  align-items: center;
}

li a {
  margin-right: 3rem;
  color: white;
  text-decoration: none;
  font-family: HelNeue;
  font-size: 16px;
  text-transform: uppercase;
  padding-bottom: 5px;
  border-bottom: 3px solid transparent;
}

li a.active {
  border-bottom: 3px solid #e6bd71;
  border-radius: 3px;
}

li a:hover {
  /* border-bottom: 3px solid #3ca4c3;
  border-radius: 3px; */
  background-image: url("../../../../assets/images/hover.svg");
  background-position: 0 100%;
  background-size: auto 46px;
  background-repeat: repeat;
  text-decoration: none;
  border-bottom: none;
  padding-bottom: 8px;
}

.custom-nav {
  height: 45px;
  /*flex-grow: 1;*/
}
</style>
